import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';

interface ChatPanelFooterProps extends BoxProps {
  children: React.ReactNode;
}

const ChatPanelFooter = ({ children, ...props }: ChatPanelFooterProps) => {
  return (
    <Box className="ChatPanelFooter fadeIn" animationDelay="0.8s" opacity={0} {...props}>
      {children}
    </Box>
  );
};

const MemoizedChatPanelFooter = memo(ChatPanelFooter);

export { MemoizedChatPanelFooter as ChatPanelFooter };
